export default __webpack_public_path__ + "static/media/Rectangle163.d24410bd.png";